"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es7.string.pad-start");
var _echarts = _interopRequireDefault(require("echarts"));
var _orderEvaluate = require("@/api/evaluate/orderEvaluate");
var _shopList = require("@/api/shop/shopList");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'overviewEvaluate',
  data: function data() {
    return {
      trendChart: null,
      monthData: [],
      scoreData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      selectedShop: '',
      dateRange: [],
      storeList: [],
      aggregateData: {},
      searchForm: {
        startDate: null,
        endDate: null,
        compareStartDate: null,
        compareEndDate: null,
        shopId: null
      }
    };
  },
  mounted: function mounted() {
    this.getShops();
    // 设置默认日期为今天（查询一天的数据）
    var formatDateTime = function formatDateTime(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    };
    var todayStr = formatDateTime(new Date());
    this.searchForm.startDate = todayStr + ' 00:00:00';
    this.searchForm.endDate = todayStr + ' 23:59:59';
    this.fetchAggregateData();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.trendChart) {
      this.trendChart.dispose();
    }
  },
  methods: {
    getShops: function getShops() {
      var _this = this;
      (0, _shopList.getStoreData)().then(function (res) {
        console.log(res.records);
        _this.storeList = res.records;
      });
    },
    fetchAggregateData: function fetchAggregateData() {
      var _this2 = this;
      // 构建请求参数
      var params = {
        shopId: this.searchForm.shopId,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        compareStartDate: this.searchForm.compareStartDate,
        compareEndDate: this.searchForm.compareEndDate
      };
      // 调用后端API获取聚合数据
      (0, _orderEvaluate.getAggregate)(params).then(function (res) {
        _this2.aggregateData = res.data;
        _this2.scoreData = res.data.historyScore;

        // 获取按月份分组的数据
        _this2.initData();
        _this2.initChart();
      });
    },
    handleFilterChange: function handleFilterChange() {
      console.log('门店:', this.selectedShop);
      console.log('日期范围:', this.dateRange);
      // 这里应该重新调用API获取筛选后的数据
    },
    // 初始化按月分组的数据
    initData: function initData() {
      var now = new Date();
      var monthNames = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];

      // 生成最近12个月的月份数据
      this.monthData = [];
      for (var i = 11; i >= 0; i--) {
        var date = new Date(now.getFullYear(), now.getMonth() - i, 1);
        this.monthData.push("".concat(date.getFullYear(), "-").concat(monthNames[date.getMonth()]));
      }

      // 生成评分数据（这里应该从后端获取实际数据）
      this.scoreData = this.aggregateData.historyScore;
      var baseScore = 4.6;
      for (var _i = 0; _i < 12; _i++) {
        var fluctuation = (Math.random() - 0.5) * 0.1;
        baseScore += fluctuation;
        baseScore = Math.max(4.5, Math.min(5.0, baseScore));
        this.scoreData.push(Number(baseScore.toFixed(2)));
      }
    },
    // 初始化图表
    initChart: function initChart() {
      var _this3 = this;
      this.$nextTick(function () {
        if (!_this3.$refs.trendChart) return;
        if (_this3.trendChart) {
          _this3.trendChart.dispose();
        }
        _this3.trendChart = _echarts.default.init(_this3.$refs.trendChart);
        var option = {
          tooltip: {
            trigger: 'axis',
            formatter: function formatter(params) {
              var data = params[0];
              return "".concat(data.name, "<br/>\u603B\u8BC4\u5206: ").concat(data.value);
            },
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderColor: '#ddd',
            borderWidth: 1,
            textStyle: {
              color: '#333'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: _this3.monthData,
            axisLabel: {
              color: '#606266',
              fontSize: 12,
              rotate: 45
            },
            axisLine: {
              lineStyle: {
                color: '#e4e7ed'
              }
            }
          },
          yAxis: {
            type: 'value',
            min: 0,
            max: 5.0,
            interval: 1,
            axisLabel: {
              color: '#606266',
              fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: '#e4e7ed'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#f0f0f0',
                type: 'dashed'
              }
            }
          },
          series: [{
            name: '总评分',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            data: _this3.scoreData,
            lineStyle: {
              width: 3,
              color: '#409eff'
            },
            itemStyle: {
              color: '#409eff',
              borderWidth: 2,
              borderColor: '#fff'
            },
            areaStyle: {
              color: new _echarts.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(64, 158, 255, 0.3)'
              }, {
                offset: 1,
                color: 'rgba(64, 158, 255, 0.05)'
              }])
            },
            emphasis: {
              scale: true,
              symbolSize: 8
            }
          }]
        };
        _this3.trendChart.setOption(option);
      });
    },
    handleResize: function handleResize() {
      if (this.trendChart) {
        this.trendChart.resize();
      }
    }
  }
};